import axios from '@/axios.js'
let token = localStorage.getItem('accessToken');
let entityURL = 'log'; // variant depending on entity URLs
let apiEndpoint = localStorage.getItem('apiEndpoint');

axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    log: [],
}

const getters = {
    getLog: (state) => (state.log),
}

const actions = {
    async fetchLog({ commit }, payload) {
        const response = await axios(`${entityURL}/list/${payload}`)
        commit('SET_LOG', response.data.object)
    },
}

const mutations = {
    SET_LOG: (state, data) => (state.log = data)
}

export default { state, getters, actions, mutations }
